import { withStateHandlers } from 'recompose';
import { pascal } from 'to-case';

export const withHintTooltip = (tooltipName: string) => {
  const name = pascal(tooltipName);

  return withStateHandlers(
    {
      [`is${name}HintOpened`]: false,
    },
    {
      [`open${name}Hint`]: () => () => ({ [`is${name}HintOpened`]: true }),
      [`close${name}Hint`]: () => () => ({ [`is${name}HintOpened`]: false }),
    },
  );
};
